import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/app/config/environments/environment';
import { LinkParamsDto } from '../models/link-params.dto';

import { CreateLink, Link } from '../models/link.interface';

@Injectable({
  providedIn: 'root',
})
export class LinksService {
  private readonly path = 'links';

  constructor(private readonly http: HttpClient) {}

  getAll(params?: LinkParamsDto): Observable<Link[]> {
    const url = `${environment.api.baseUrl}/${this.path}`;
    return this.http
      .get<Link[]>(url, {
        params: this.buildParams(params),
      })
      .pipe((response) => response);
  }

  createMany(links: CreateLink[]): Observable<String> {
    return this.http.post(`${environment.api.baseUrl}/${this.path}`, links, {
      responseType: 'text',
    });
  }

  deleteMany(params?: LinkParamsDto): Observable<any> {
    return this.http.delete(
      `${environment.api.baseUrl}/${this.path}`,
      { params: this.buildParams(params) }
    );
  }

  private buildParams(params?: LinkParamsDto): any {
    const httpParams: any = {};

    if (params?.idSchool) {
      httpParams.idSchool = params.idSchool;
    }
    return httpParams;
  }
}
